"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../index");

var _react = _interopRequireWildcard(require("react"));

var _reactFullstoryComponent = require("react-fullstory-component");

var _uuid = require("uuid");

var _common = require("./common");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/**
 * Full story component
 *
 * @returns {React.Component}
 */


var FullStoryTracker =
/*#__PURE__*/
function (_Component) {
  _inherits(FullStoryTracker, _Component);

  function FullStoryTracker(props) {
    var _this;

    _classCallCheck(this, FullStoryTracker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FullStoryTracker).call(this, props)); // TODO: get rid of directly reading static configuration, these should arrive as props

    var _getConfig = (0, _index.getConfig)(),
        FULL_STORY_DEBUG = _getConfig.FULL_STORY_DEBUG,
        FULL_STORY_ORG_CODE = _getConfig.FULL_STORY_ORG_CODE,
        FULL_STORY_ORG_CODE_BY_ENV = _getConfig.FULL_STORY_ORG_CODE_BY_ENV,
        DEFAULT_BRAND = _getConfig.DEFAULT_BRAND; // Check if we have an environment specific configuration and fallback to the default one


    var host = window.location.host;
    var orgKey = (0, _common.getEnvSpecificConfig)(FULL_STORY_ORG_CODE_BY_ENV, host, DEFAULT_BRAND) || FULL_STORY_ORG_CODE;
    _this.settings = {
      orgKey: orgKey,
      host: 'fullstory.com',
      debug: FULL_STORY_DEBUG // Each user should get unique session ID upon app opening

    };
    _this.sessionId = (0, _uuid.v4)();
    return _this;
  }

  _createClass(FullStoryTracker, [{
    key: "render",
    value: function render() {
      // render tracker code when orgKey is available
      return this.settings.orgKey && _react.default.createElement(_reactFullstoryComponent.FullStory, {
        settings: this.settings,
        sessionId: this.sessionId
      });
    }
  }]);

  return FullStoryTracker;
}(_react.Component);

exports.default = FullStoryTracker;